import { render, staticRenderFns } from "./bodyA.vue?vue&type=template&id=7ca11d7c&scoped=true&"
import script from "./bodyA.vue?vue&type=script&lang=js&"
export * from "./bodyA.vue?vue&type=script&lang=js&"
import style0 from "./bodyA.vue?vue&type=style&index=0&id=7ca11d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca11d7c",
  null
  
)

export default component.exports